import React, { useState, useEffect } from 'react';
import { token,BASEAPIURL } from '../../env';
import SportsSlot from './SportsSlot';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';

const ITEM_HEIGHT = 60;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const CourtsManagement = () => {
  const [courts, setCourts] = useState([]);
   const theme = useTheme();
      const [loading, setLoading] = useState(true);
      const [loadingSolt, setLoadingSolt] = useState(true);
      const [error, setError] = useState(null);
      const [expandedId, setExpandedId] = useState(null);
    const [loadingCourts, setLoadingCourts] = useState(false);
      
      const handleToggle = (courtId) => {
  // If clicking the same row, close it. Otherwise, open the new one.
  setExpandedId(expandedId === courtId ? null : courtId);
};
      
      // Facility Groups + Facilities
      const [facilityGroups, setFacilityGroups] = useState([]);
      const [facilities, setFacilities] = useState([]);
      const [slotDataByCourtId, setSlotDataByCourtId] = useState([]);
      const [selectedFGrpID, setSelectedFGrpID] = useState("");
      console.log({selectedFGrpID});
      
      // Form & Modal
      const [showSlot, setShowSlot] = useState(false)
      const [showForm, setShowForm] = useState(false);
      const [showFormCourts, setShowFormCourts] = useState(false);
      const [isEditing, setIsEditing] = useState(false);
      const [isSaving, setIsSaving] = useState(false);
      const [deletingId, setDeletingId] = useState(null);
    
   const [currentCourt, setCurrentCourt] = useState({
        CourtID: null,
        CourtName: '',
        CourtDes: '',
        Location: '',
        FacilityID: '',
        IsActive: true,
      });
        const [currentSlot, setCurrentSlot] = useState({
          SlotName: '',
          Duration: '',
          startTime:'',
          endTime:'',
          CourtID: '',
          FacilityID: '',
          MemberPrice: '',
          GuestPrice: '',
          BookingAllowed: 'Yes',
          PlayerAllowed: '4',
          TaxIsInclude: false,
          IsEachPerson: false,
          TaxPercentage: 0,
          Discountper: 0,
          SlotDays: [],
          IsActive: true,
        });


        // Open Add Form
  const handleAdd = () => {
    setCurrentSlot({
      SlotName: '',
      Duration: '',
      startTime:'',
      endTime:'',
      CourtID: '',
      FacilityID: '',
      MemberPrice: '',
      GuestPrice: '',
      BookingAllowed: 'Yes',
      PlayerAllowed: '4',
      TaxIsInclude: false,
      IsEachPerson: false,
      TaxPercentage: 0,
      Discountper: 0,
      SlotDays: [],
      IsActive: true,
    });
    setIsEditing(false);
    setShowForm(true);
  };

        const handleAddCourt = () => {
      setCurrentCourt({
        CourtName: '',
        CourtDes: '',
        Location: '',
        FacilityID: '',
        IsActive: true,
      });
      setIsEditing(false);
      setShowFormCourts(true);
    };
    

      // 🔹 Fetch Courts on Mount
      useEffect(() => {
        fetchCourts();
        fetchFacilityGroups(); // Load facility groups at start
      }, []);
    
      const fetchCourts = async () => {
        setLoading(true);
        setError(null);
        try {
          const url = `${BASEAPIURL}/GetFacilityCourts?Token=${encodeURIComponent(token)}`;
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const result = await response.json();
          if (result.status) setCourts(result.data);
          else setError(result.error || 'Failed to load courts');
        } catch (err) {
          setError(err.message || 'Network error');
        } finally {
          setLoading(false);
        }
      };
    
      // 🔹 Fetch Facility Groups
      const fetchFacilityGroups = async () => {
        try {
          const res = await fetch(
            `${BASEAPIURL}/GetFGrpList?token=${encodeURIComponent(token)}`
          );
          const data = await res.json();
          if (data.status) setFacilityGroups(data.data || []);
        } catch (err) {
          console.error("Facility Groups Error:", err);
        }
      };

    
      // 🔹 Fetch Facilities by Facility Group
      const fetchFacilitiesByGroup = async (fGrpID) => {
        setFacilities([]);
        try {
          const res = await fetch(
            `${BASEAPIURL}/GetFacilityBookingByFGrpID?FGrpID=${fGrpID}&Token=${encodeURIComponent(token)}`
          );
          const data = await res.json();
          if (data.status) setFacilities(data.data || []);
        } catch (err) {
          console.error("Facilities Error:", err);
        }
      };

        // 🔹 Fetch slot by court id
      const GetSlotbyCourtID  = async (courtId) => {
        setLoadingSolt(true);
        setSlotDataByCourtId([]);
        try {
          const res = await fetch(
            `${BASEAPIURL}/GetSlotbyCourtID?CourtID=${courtId}&Token=${encodeURIComponent(token)}`
          );
          const data = await res.json();
          if (data.status) setSlotDataByCourtId(data.data || []);
        } catch (err) {
          console.error("Facilities Error:", err);
        } finally {
          setLoadingSolt(false);
        }
      };
    
      useEffect(() => {
  if (expandedId) {
    GetSlotbyCourtID(expandedId);
  }
}, [expandedId])

      // Handle Input Change
      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setCurrentCourt((prev) => ({
          ...prev,
          [name]: type === 'checkbox' ? checked : value,
        }));
      };

        const handleChangeSlot = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentSlot((prev) => {
      const updatedSlot = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };

      // If CourtID changes, update FacilityID
      if (name === 'CourtID') {
        const selectedCourt = courts.find((court) => court.CourtID === parseInt(value));
        updatedSlot.FacilityID = selectedCourt ? selectedCourt.FacilityID : '';
      }

      return updatedSlot;
    });
  };
    
      // 🔹 Facility Group selection change
      const handleGroupChange = (e) => {
        const fGrpID = e.target.value;
        setSelectedFGrpID(fGrpID);
        setCurrentCourt((prev) => ({ ...prev, FacilityID: "" }));
        if (fGrpID) fetchFacilitiesByGroup(fGrpID);
      };
  
      // Open Edit Form
      const handleEdit = (court) => {
        setCurrentCourt({
          CourtID: court.CourtID|| '',
          CourtName: court.CourtName || '',
          CourtDes: court.CourtDes || '',
          Location: court.Location || '',
          FacilityID: court.FacilityID || '',
          IsActive: court.IsActive ?? true,
        });
        setIsEditing(true);
        setShowFormCourts(true);
      };

        // Update the handleEdit function to include SlotID and FacilityID
  const handleEditSlot = (slot) => {
    
    const selectedCourt = courts.find((court) => court.CourtID === slot.CourtID);
    setCurrentSlot({
      SlotName: slot.SlotName || '',
      startTime:slot.StartTime,
      endTime:slot.EndTime,
      // Duration: slot.Duration || '',
      CourtID: slot.CourtID || '',
      FacilityID: selectedCourt ? selectedCourt.FacilityID : slot.FacilityID || '',
      MemberPrice: slot.MemberPrice || '',
      GuestPrice: slot.GuestPrice || '',
      BookingAllowed: slot.BookingAllowed || 'Yes',
      PlayerAllowed: slot.PlayerAllowed || '4',
      TaxIsInclude: slot.TaxIsInclude || false,
      IsEachPerson: slot.IsEachPerson || false,
      TaxPercentage: slot.TaxPercentage || 0,
      Discountper: slot.Discountper || 0,
      SlotDays: slot.SlotDays || [],
      IsActive: slot.IsActive ?? true,
      SlotID: slot.SlotID,
    });
    setIsEditing(true);
    setShowForm(true);
  };
    
      // Handle Delete
      const handleDelete = async (courtId) => {
        if (!window.confirm('Are you sure you want to delete this court?')) return;
        setDeletingId(courtId);
        try {
          // 🔹 Re-run facility group fetch before delete (as per requirement)
          await fetchFacilityGroups();
    
          const payload = { Token: token, CourtID: courtId };
          const response = await fetch(`${BASEAPIURL}/DeleteCourt`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (result.status) {
            setCourts((prev) => prev.filter((c) => c.CourtID !== courtId));
            alert('Court deleted successfully!');
          } else {
            throw new Error(result.error || 'Delete failed');
          }
        } catch (err) {
          alert(`Failed to delete court: ${err.message}`);
        } finally {
          setDeletingId(null);
        }
      };
    
      // Submit Add/Edit
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!currentCourt.CourtName?.trim()) {
          alert('Court Name is required.');
          return;
        }
        if (!currentCourt.FacilityID) {
          alert('Please select a Facility.');
          return;
        }
    
        setIsSaving(true);
    
        const courtPayload = {
         
        };
    
      
    
        try {
          let response;
          if (isEditing) {
            const updateUrl = `${BASEAPIURL}/UpdateFacilityCourt?CourtID=${currentCourt.CourtID}`;
            response = await fetch(updateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                tokenData: token,
                FacilityCourt: {
                  CourtName: currentCourt.CourtName,
                  CourtDes: currentCourt.CourtDes,
                  Location: currentCourt.Location,
                  FacilityID: currentCourt.FacilityID,
                  IsActive: currentCourt.IsActive,
                }
              }),
              
            });
          } else {
            // 🔹 Re-run facility group fetch before add
            await fetchFacilityGroups();
    
            response = await fetch(`${BASEAPIURL}/InsertFacilityCourt`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                tokenData: token,
                FacilityCourt: {
                  CourtID: currentCourt.CourtID,
                  CourtName: currentCourt.CourtName,
                  CourtDes: currentCourt.CourtDes,
                  Location: currentCourt.Location,
                  FacilityID: currentCourt.FacilityID,
                  IsActive: currentCourt.IsActive,
                }
              }),
            });
          }
    
          const result = await response.json();
          if (result.status) {
            await fetchCourts();
            alert(`Court ${isEditing ? 'updated' : 'added'} successfully!`);
            setShowFormCourts(false);
          } else {
            throw new Error(result.error || 'Action failed');
          }
        } catch (err) {
          alert(`Failed to ${isEditing ? 'update' : 'add'} court: ${err.message}`);
        } finally {
          setIsSaving(false);
        }
      };

      const formatTimeToHHMMSS = (time) => {
  if (!time) return "00:00:00";

  const parts = time.split(":");

  const hours = parts[0]?.padStart(2, "0") || "00";
  const minutes = parts[1]?.padStart(2, "0") || "00";
  const seconds = parts[2]?.padStart(2, "0") || "00";

  return `${hours}:${minutes}:${seconds}`;
};
        // Submit Add/Edit Slot
        const handleSubmitSlot = async (e) => {
          e.preventDefault();
          if (!currentSlot.SlotName?.trim()  || !currentSlot.CourtID) {
            alert('Slot Name, Duration, and Court are required.');
            return;
          }
      
          setIsSaving(true);
      
          const slotPayload = {
            SlotName: currentSlot.SlotName,
             startTime: formatTimeToHHMMSS(currentSlot.startTime),
            endTime: formatTimeToHHMMSS(currentSlot.endTime),
            CourtID: parseInt(currentSlot.CourtID) || null,
            FacilityID: parseInt(currentSlot.FacilityID) || 0,
            MemberPrice: parseFloat(currentSlot.MemberPrice) || 0,
            GuestPrice: parseFloat(currentSlot.GuestPrice) || 0,
            BookingAllowed: currentSlot.BookingAllowed,
            PlayerAllowed: currentSlot.PlayerAllowed,
            TaxIsInclude: currentSlot.TaxIsInclude,
            IsEachPerson: currentSlot.IsEachPerson,
            TaxPercentage: parseFloat(currentSlot.TaxPercentage) || 0,
            Discountper: parseFloat(currentSlot.Discountper) || 0,
            SlotDays: currentSlot.SlotDays || [],
            IsActive: currentSlot.IsActive,
          };
      
          try {
            let response;
            if (isEditing) {
              const updatePayload = {
                tokenData: token,
                SlotID: currentSlot.SlotID,
                Slot: slotPayload,
              };
      
              response = await fetch(`${BASEAPIURL}/UpdateFacilitySlot?SlotID=${currentSlot.SlotID}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatePayload),
              });
            } else {
              const payload = {
                tokenData: token,
                Slot: slotPayload,
              };
      
              response = await fetch(`${BASEAPIURL}/InsertFacilitySlot`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
              });
            }
      
            const result = await response.json();
            console.log('API Response:', result);
      
            if (result.data) {
              // await fetchSlots();
              GetSlotbyCourtID(expandedId)
              alert(`Slot ${isEditing ? 'updated' : 'added'} successfully!`);
              setShowForm(false);
            } else {
              throw new Error(result.error || 'Action failed');
            }
          } catch (err) {
            console.error('Save Error:', err);
            alert(`Failed to ${isEditing ? 'update' : 'add'} slot: ${err.message}`);
          } finally {
            setIsSaving(false);
          }
        };

  // 🔹 UI
  // if (loading) return <div className="text-center py-5">🔄 Loading courts...</div>;

  return (
    <div className="p-3">
 {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className='bg-light border'>
          <button className={` ${!showSlot && 'bg-transparent'}`} onClick={() => setShowSlot(false)}><h5 className='text-black'>🎾 Courts Management</h5></button>
          {/* <button className={` ${showSlot && 'bg-transparent'}`} onClick={() => setShowSlot(true)}><h5 className="text-dark" >🏸 Facility Time Slots</h5></button> */}
        </div>
        {/* {showSlot ?<button className="btn btn-success px-4" 
        onClick={handleAdd}
        >
          <i className="bi bi-plus-circle me-2"></i>Add Slot
        </button>: <button className="btn btn-success" onClick={handleAddCourt}>
          ➕ Add Court
        </button>} */}
        {showSlot ?<button className="btn btn-success px-4" 
        onClick={handleAdd}
        >
          <i className="bi bi-plus-circle me-2"></i>Add Slot
        </button>: <div>
        <button className="btn btn-success px-4 me-3" 
        onClick={handleAdd}
        >
          <i className="bi bi-plus-circle me-2"></i>Add Slot
        </button>
        <button className="btn btn-success" onClick={handleAddCourt}>
          ➕ Add Court
        </button></div>}
      </div>

      <div className=" mt-4">
      {/* Courts Table */}
       {/* {!showSlot ? (courts.length === 0 ? (
        <div className="alert alert-info text-center">📭 No Courts available.</div>
      ) : (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Court</th>
              <th>Description</th>
              <th>Location</th>
              <th>Facility Name</th>
              <th>Status</th>
              <th>⚙️ Actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {courts.map((court, i) => (
              <tr key={court.CourtID}>
                <td>{i + 1}</td>
                <td>{court.CourtName}</td>
                <td>{court.CourtDes}</td>
                <td>{court.Location}</td>
                <td>{court.FacilityName}</td>
                <td>{court.IsActive ? "✅ Active" : "❌ Inactive"}</td>
                <td>
                  <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(court)}>✏️</button>
                  {/* <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(court.CourtID)}
                    disabled={deletingId === court.CourtID}
                  >
                    {deletingId === court.CourtID ? "Deleting..." : "🗑️"}
                  </button> *
                </td>
                <td><FaAngleDown /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>)): <SportsSlot showForm={showForm} setShowForm={setShowForm}/>} */}
       {loading ? (
  <div className="text-center my-4">
      <span>Loading...</span>
  </div>
) : (courts.length === 0 ? (
        <div className="alert alert-info text-center">📭 No Courts available.</div>
      ) : (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Court</th>
              <th>Description</th>
              <th>Location</th>
              <th>Facility Name</th>
              <th>Status</th>
              <th>⚙️ Actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
  {courts.map((court, i) => (
    <React.Fragment key={court.CourtID}>
      <tr>
        <td>{i + 1}</td>
        <td>{court.CourtName}</td>
        <td>{court.CourtDes}</td>
        <td>{court.Location}</td>
        <td>{court.FacilityName}</td>
        <td>{court.IsActive ? "✅ Active" : "❌ Inactive"}</td>
        <td>
          <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(court)}>✏️</button>
        </td>
        
        {/* Toggle Icon Cell */}
        <td onClick={() => {handleToggle(court.CourtID)}} style={{ cursor: 'pointer' }}>
          {expandedId === court.CourtID ? <FaAngleUp fontSize={25} /> : <FaAngleDown fontSize={25} />}
        </td>
      </tr>

      {/* 2. Expanded Row (Only shows if this specific ID matches) */}
      {expandedId === court.CourtID && (
        
        <tr>
          <td colSpan="8" style={{ padding: '0' }}> 
            {loadingSolt ? (
  <div className="text-center my-4">
      <span>Loading...</span>
  </div>
) :slotDataByCourtId.length === 0 ? (
        <div className="alert alert-info text-center">📭 No slots available.</div>
      ) : (<div>
              <table className="table table-hover align-middle mb-0">
               <thead className="table-light">
                 <tr>
                <th>#</th>
                <th>Name</th>
                <th>Duration</th>
                {/* <th>Court ID</th>
                <th>Facility ID</th>*/} 
                <th>Players</th>
                <th>Member (₹)</th>
                <th>Guest (₹)</th>
                <th>Booking</th>
                <th>Tax</th>
                <th>Each Person</th>
                <th>Tax %</th>
                <th>Dis %</th>
                <th>Slot Days</th>
                <th>Status</th>
                <th className="text-center">Actions</th>
              </tr>
                </thead>
                <tbody>
                  {slotDataByCourtId.map((slot, index) => (
                <tr key={slot.SlotID}>
                  <td>{index + 1}</td>
                  <td><strong>{slot.SlotName}</strong></td>
                  <td>
                    <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
                      {slot.Duration}
                    </span>
                  </td>
                  {/* <td><code>{slot.CourtID}</code></td>
                  <td><code>{slot.FacilityID}</code></td> */}
                  <td><strong className="text-success">{slot.PlayerAllowed}</strong></td>
                  <td>{slot.MemberPrice ? `₹${slot.MemberPrice}` : '—'}</td>
                  <td>{slot.GuestPrice ? `₹${slot.GuestPrice}` : '—'}</td>
                  <td>
                    {slot.BookingAllowed === 'Yes'
                      ? <span className="badge text-bg-success">Yes</span>
                      : <span className="badge text-bg-danger">No</span>}
                  </td>
                  <td>
                    {slot.TaxIsInclude
                      ? <span className="badge text-bg-success">Included</span>
                      : <span className="badge text-bg-warning">Excluded</span>}
                  </td>
                  <td>
                    {slot.IsEachPerson
                      ? <span className="badge text-bg-success">Yes</span>
                      : <span className="badge text-bg-warning">No</span>}
                  </td>
                  <td>{slot.TaxPercentage ? `${slot.TaxPercentage}%` : '—'}</td>
                  <td>{slot.Discountper ? `${slot.Discountper}%` : '—'}</td>
                  {/* <td>{slot.SlotDays ? `${slot.SlotDays}...` : '—'}</td> */}
                  <td>
  {slot.SlotDays && slot.SlotDays.length > 0 ? (
    <span
      data-toggle="tooltip"
      data-placement="top"
      title={slot.SlotDays.slice(1).join(", ")}
      style={{ cursor: "pointer" }}
    >
      {slot.SlotDays[0]}
      {slot.SlotDays.length > 1 ? "..." : ""}
    </span>
  ) : (
    "—"
  )}
</td>
                  <td>
                    {slot.IsActive
                      ? <span className="badge text-bg-success">Active</span>
                      : <span className="badge text-bg-secondary">Inactive</span>}
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEditSlot(slot)}
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </tr>
              ))}
                </tbody>
              </table>
            </div>)}
          </td>
        </tr>
     
      )}
    </React.Fragment>
  ))}
</tbody>
        </table>
      </div>))}
      {/*  <SportsSlot showForm={showForm} setShowForm={setShowForm}/> */}
      

      {/* Modal */}
      {showFormCourts && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5>{isEditing ? "✏️ Edit Court" : "➕ Add Court"}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowFormCourts(false)}></button>
                </div>

                <div className="modal-body">
                  {/* Facility Group */}
                  <div className="mb-3">
                    <label className="form-label">Facility Group</label>
                    <select
                      className="form-select"
                      value={selectedFGrpID}
                      onChange={handleGroupChange}
                    >
                      <option value="">-- Select Group --</option>
                      {facilityGroups.map((g) => (
                        <option key={g.FacilityGroupID} value={g.FacilityGroupID}>
                          {g.FacilityName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Facility */}
                  <div className="mb-3">
                    <label className="form-label">Facility</label>
                    <select
                      className="form-select"
                      name="FacilityID"
                      value={currentCourt.FacilityID}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Facility --</option>
                      {facilities.map((f) => (
                        <option key={f.Facility_ID} value={f.Facility_ID}>
                          {f.Facility_Name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Court Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="CourtName"
                      value={currentCourt.CourtName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="CourtDes"
                      value={currentCourt.CourtDes}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Location</label>
                    <input
                      type="text"
                      className="form-control"
                      name="Location"
                      value={currentCourt.Location}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="IsActive"
                      checked={currentCourt.IsActive}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">Active</label>
                  </div>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowFormCourts(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={isSaving}>
                    {isSaving ? "Saving..." : isEditing ? "💾 Update" : "✅ Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}


        {/* Add/Edit slot Modal */}
            {showForm && (
              <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <form onSubmit={handleSubmitSlot}>
                      <div className="modal-header">
                        <h5 className="modal-title">{isEditing ? '✏️ Edit Slot' : '➕ Add New Slot'}</h5>
                        <button type="button" className="btn-close" onClick={() => setShowForm(false)}></button>
                      </div>
      
                      <div className="modal-body">
                        <div className='row'>
                          <div className="mb-3 col-5">
                            <label className="form-label">Slot Name *</label>
                            <input
                              type="text"
                              className="form-control py-1"
                              name="SlotName"
                              value={currentSlot.SlotName}
                              onChange={handleChangeSlot}
                              placeholder="e.g. Morning Slot"
                              required
                            />
                          </div>
                          <div className="mb-3 col-5 offset-1">
                            <label className="form-label">Select Court *</label>
                            {loadingCourts ? (
                              <div className="form-control text-muted">Loading courts...</div>
                            ) : courts.length === 0 ? (
                              <div className="form-control text-danger">No courts found</div>
                            ) : (
                              <select
                                className="form-control py-1"
                                name="CourtID"
                                value={currentSlot.CourtID || ''}
                                onChange={handleChangeSlot}
                                required
                              >
                                <option value="">-- Select a Court --</option>
                                {courts.map((court) => (
                                  <option key={court.CourtID} value={court.CourtID}>
                                    🏟️ {court.CourtName} | {court.FacilityName} | ID: {court.CourtID}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-3 col-5">
                            <label className="form-label">Start Duration *</label>
                             <input
                            type="time"
                            className="form-control py-1"
                            name="startTime"
                            value={currentSlot.startTime}
                            onChange={handleChangeSlot}
                            placeholder=" 09:00 PM"
                            required
                          />
                          
                          </div>
                          <div className="mb-3 col-5 offset-1">
                            <label className="form-label">End Duration *</label>
                               <input
                            type="time"
                            className="form-control py-1"
                            name="endTime"
                            value={currentSlot.endTime}
                            onChange={handleChangeSlot}
                            placeholder=" 09:00 PM"
                            required
                          />
                          
                          </div>
                        </div>
                        <div className='row'>
                          {/* <div className="mb-3 col-5">
                            <label className="form-label">Facility ID</label>
                            <input
                              type="text"
                              className="form-control py-1"
                              name="FacilityID"
                              value={currentSlot.FacilityID}
                              readOnly
                            />
                          </div> */}
                           <div className="mb-3 col-5">
                            <label className="form-label">Slot Days</label>
                            <FormControl className="form-control" >
                              <Select
                                multiple
                                displayEmpty
                                className='py-1'
                                name="SlotDays"
                                value={currentSlot.SlotDays}
                                onChange={handleChangeSlot}
                                input={<OutlinedInput />}
                                sx={{
                                  '& .MuiSelect-select': { paddingY: '1px' }
                                }}
                                renderValue={(selected) => (
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {
                                      selected.length === 0 ?
                                        <em>Select a days</em> :
                                        selected.map((value) => (
                                          <Chip key={value} label={value} />
                                        ))}
                                  </Box>
                                )}
                                MenuProps={MenuProps}
                              >
                                {daysOfWeek.map((name) => (
                                  <MenuItem
                                    key={name}
                                    value={name}
                                    style={getStyles(name, currentSlot.SlotDays, theme)}
                                  >
                                    {name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
      
      
                          </div>
                          <div className="mb-3 col-5 offset-1">
                            <label className="form-label">Players Allowed</label>
                            <input
                              type="number"
                              className="form-control py-1"
                              name="PlayerAllowed"
                              value={currentSlot.PlayerAllowed}
                              onChange={handleChangeSlot}
                              min="2"
                              max="23"
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-3 col-5">
                            <label className="form-label">Member Price (₹)</label>
                            <input
                              type="number"
                              step="0.01"
                              className="form-control py-1"
                              name="MemberPrice"
                              value={currentSlot.MemberPrice}
                              onChange={handleChangeSlot}
                            />
                          </div>
      
                          <div className="mb-3 col-5 offset-1">
                            <label className="form-label">Guest Price (₹)</label>
                            <input
                              type="number"
                              step="0.01"
                              className="form-control py-1"
                              name="GuestPrice"
                              value={currentSlot.GuestPrice}
                              onChange={handleChangeSlot}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-3 col-5">
                            <label className="form-label">Tax Percentage (%)</label>
                            <input
                              type="number"
                              className="form-control py-1"
                              name="TaxPercentage"
                              value={currentSlot.TaxPercentage}
                              onChange={handleChangeSlot}
                              min="0"
                              max="100"
                              step="0.01"
                            />
                          </div>
                          <div className="mb-3 col-5 offset-1">
                            <label className="form-label">Discount Percentage (%)</label>
                            <input
                              type="number"
                              className="form-control py-1"
                              name="Discountper"
                              value={currentSlot.Discountper}
                              onChange={handleChangeSlot}
                              min="0"
                              max="100"
                              step="0.01"
                            />
                          </div>
                        </div>
                     
                        <div className='row ms-1'>
                          <div className="form-check form-switch mb-3 col-6">
                            <input
                              type="checkbox"
                              id="BookingAllowed"
                              role='switch'
                              className="form-check-input px-4"
                              name="BookingAllowed"
                              checked={currentSlot.BookingAllowed === 'Yes'}
                              onChange={(e) =>
                                setCurrentSlot((prev) => ({
                                  ...prev,
                                  BookingAllowed: e.target.checked ? 'Yes' : 'No',
                                }))
                              }
                            />
                            <label htmlFor="BookingAllowed" className="form-check-label ms-2">
                              Allow Booking
                            </label>
                          </div>
                          <div className="form-check form-switch mb-3 col-6">
                            <input
                              type="checkbox"
                              id="TaxIsInclude"
                              className="form-check-input px-4"
                              name="TaxIsInclude"
                              checked={currentSlot.TaxIsInclude}
                              onChange={handleChangeSlot}
                            />
                            <label htmlFor="TaxIsInclude" className="form-check-label ms-2">
                              Tax Included in Price
                            </label>
                          </div>
                        </div>
                        <div className='row ms-1'>
                          <div className="form-check form-switch mb-3 col-6">
                            <input
                              type="checkbox"
                              role="switch"
                              id="IsEachPerson"
                              className="form-check-input px-4"
                              name="IsEachPerson"
                              checked={currentSlot.IsEachPerson}
                              onChange={handleChangeSlot}
                            />
                            <label htmlFor="IsEachPerson" className="form-check-label ms-2">
                              Price Per Person
                            </label>
                          </div>
      
                          <div className="form-check form-switch mb-3 col-6">
                            <input
                              type="checkbox"
                              id="IsActive"
                              className="form-check-input px-4"
                              name="IsActive"
                              checked={currentSlot.IsActive}
                              onChange={handleChangeSlot}
                            />
                            <label htmlFor="IsActive" className="form-check-label ms-2">
                              Active
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowForm(false)}
                          disabled={isSaving}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={isSaving}>
                          {isSaving ? 'Saving...' : isEditing ? '💾 Update Slot' : '✅ Add Slot'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
    </div></div>)
    
};
export default CourtsManagement;